/* eslint-disable */
import AFRAME from 'aframe';
import { modalShow,modalShowFull } from './animations';


AFRAME.registerComponent('main',{
    init: function(){
        console.log('component initialized');
        this.el.addEventListener('click', (e)=>{
            let current = e.detail.intersection.object.name;
            console.log(current);
            if(current === 'bt_fauna'){
                modalShow(document.querySelector('.modal_primary_fauna'),'primary');
            }else if(current === 'bt_cortes'){
                //modalShow(document.querySelector('.modal_secondary'),'secondary');
                modalShow(document.querySelector('.modal_tertiary'),'tertiary');
                modalShowFull(document.querySelector('.modal_tertiary_full'),document.querySelector('.container'),'tertiary');
            }else if(current === 'bt_flora'){
                modalShow(document.querySelector('.modal_primary_flora'),'primary');
            }else if(current === 'buey_proxy'){
                modalShow(document.querySelector('.modal_tertiary'),'tertiary');
            }
        })
    }
})